import {
  RiBookFill,
  RiTimerFill,
} from 'react-icons/ri'
import {
  MdCelebration,
  MdInsertPhoto,
} from 'react-icons/md'
import {
  BsLine,
  BsFillLightningFill,
  BsQuestionCircleFill,
  BsMegaphoneFill,
  BsFillBellFill,
} from 'react-icons/bs'
import { BiSticker, BiLike } from 'react-icons/bi'
import {
  FaTiktok,
  FaDiscord,
  FaFlickr,
  FaSpotify,
  FaPinterestP,
  FaBlogger,
  FaHeart,
  FaRegSmile,
  FaInfoCircle,
  FaComments,
  FaMicrophone,
  FaStoreAlt,
  FaShoppingCart,
  FaVideo,
  FaTelegramPlane,
} from 'react-icons/fa'
import {
  IoShareSocial,
  IoMailOutline,
  IoLogoTwitch,
} from 'react-icons/io5'
import {
  SiApplepodcasts,
  SiPlurk,
} from 'react-icons/si'
import {
  TiSocialLinkedin,
  TiSocialVimeo,
} from 'react-icons/ti'
import {
  AiOutlineFacebook,
  AiOutlineInstagram,
  AiOutlineTwitter,
  AiOutlineYoutube,
  AiOutlineGithub,
  AiOutlineMedium,
  AiOutlineBehance,
  AiFillStar,
  AiFillPushpin,
  AiFillShopping,
} from 'react-icons/ai'
import { GiCampingTent } from 'react-icons/gi'
import {
  HiOutlineEmojiHappy,
  HiPencil,
  HiMusicNote,
} from 'react-icons/hi'

const icons = {
  smile: FaRegSmile,
  store: FaStoreAlt,
  email: IoMailOutline,
  timer: RiTimerFill,
  lightning: BsFillLightningFill,
  heart: FaHeart,
  book: RiBookFill,
  like: BiLike,
  facebook: AiOutlineFacebook,
  instagram: AiOutlineInstagram,
  youtube: AiOutlineYoutube,
  twitter: AiOutlineTwitter,
  twitch: IoLogoTwitch,
  tiktok: FaTiktok,
  discord: FaDiscord,
  behance: AiOutlineBehance,
  flickr: FaFlickr,
  applePodcasts: SiApplepodcasts,
  spotify: FaSpotify,
  line: BsLine,
  celebration: MdCelebration,
  photo: MdInsertPhoto,
  question: BsQuestionCircleFill,
  megaphone: BsMegaphoneFill,
  bell: BsFillBellFill,
  sticker: BiSticker,
  pinterest: FaPinterestP,
  blogger: FaBlogger,
  info: FaInfoCircle,
  comments: FaComments,
  microphone: FaMicrophone,
  shoppingCart: FaShoppingCart,
  video: FaVideo,
  share: IoShareSocial,
  plurk: SiPlurk,
  linkedIn: TiSocialLinkedin,
  vimeo: TiSocialVimeo,
  github: AiOutlineGithub,
  medium: AiOutlineMedium,
  star: AiFillStar,
  shoppingBag: AiFillShopping,
  pushpin: AiFillPushpin,
  camping: GiCampingTent,
  emoji: HiOutlineEmojiHappy,
  pencil: HiPencil,
  music: HiMusicNote,
  telegram: FaTelegramPlane,
}

export default icons
